export function getNotifications(state) {
    return state.notifications;
}
export function hasNewNotification(state){
    return state.notifications.some(notification=>!notification.isRead);
}